import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const AssessmentReminderPopup = ({ show, dismiss, assessment }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleContinue = () => {
    let path = "/pain-score";
    if (assessment === "BASDAI") {
      path = "/pain-score/ankylosing-spondylitis?assessment=BASDAI";
    } else if (assessment === "BASFI") {
      path = "/pain-score/ankylosing-spondylitis?assessment=BASFI";
    } else if (assessment === "RAPID3") {
      path = "/pain-score/rheumatoid-arthritis?assessment=RAPID3";
    }
    history.push(path);
  };

  return (
    <Modal show={show} onHide={dismiss} centered>
      <Modal.Dialog className="max-w-md">
        <Modal.Header className="border-0 pb-0 text-center d-block">
          <Modal.Title className="d-flex flex-column align-items-center gap-2 fs-5">
            <span>Assessment Reminder</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center text-base text-muted">
          {assessment === "BASDAI" && (
            <p>{t("assessmentReminderPopup.basdaiReminderPopupMsg")}</p>
          )}
          {assessment === "BASFI" && (
            <p>{t("assessmentReminderPopup.basfiReminderPopupMsg")}</p>
          )}
          {assessment === "RAPID3" && (
            <p>{t("assessmentReminderPopup.rapid3ReminderPopupMsg")}</p>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex flex-column gap-2">
          <Button
            variant="outline-secondary"
            className="w-100"
            onClick={dismiss}
          >
            {t("assessmentReminderPopup.common.dismiss")}
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "var(--primarycolor)" }}
            className="w-100 text-white bg-rose-500"
            onClick={handleContinue}
          >
            {t("assessmentReminderPopup.common.continue")}
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default AssessmentReminderPopup;
